import React, { useContext } from "react";
import { Link, useHistory } from "react-router-dom";
import uuidv4 from "uuid/v4";
import { BreakpointContext } from "components/common/wrappers/withBreakpoint";
import { Button, Fab } from "@material-ui/core";
import classnames from "classnames";
import { useDispatch } from "react-redux";
import { addBatchId } from "state/reducers/communicationBatching";

const MarketingNavigation = ({ children }) => {
  const dispatch = useDispatch();
  const { push } = useHistory();

  const { isBelow } = useContext(BreakpointContext);
  const isBelowSm = isBelow("sm");
  return (
    <div
      className={classnames({
        "flex flex-wrap justify-center py-2 mx-1 mt-2 px-1 items-center":
          isBelowSm,
        "flex flex-wrap py-2 mx-1 mt-2 px-1 items-center": !isBelowSm,
      })}
    >
      <Fab
        className="focus:outline-none focus:border-none my-5"
        style={{
          boxShadow: "none",
          margin: "0 0.5em",
          width: "27px",
          height: "27px",
          minHeight: "unset",
        }}
        onClick={() => {
          const newBatchId = uuidv4();
          const { payload: batchId } = dispatch(addBatchId(newBatchId));
          push(`/v2-marketing/batch-details/${batchId}`);
        }}
      >
        <i className="fas fa-plus mx-auto" />
      </Fab>
      <Link to="/v2-marketing">
        <Button style={{ margin: "0 0.2em" }} size="small">
          <p className="px-1">home</p>
        </Button>
      </Link>
      <Link to="/v2-marketing/analytics">
        <Button style={{ margin: "0 0.2em" }} size="small">
          <p className="px-1">anayltics</p>
        </Button>
      </Link>
    </div>
  );
};

export default MarketingNavigation;
